import BasePriceBinder from './BasePriceBinder';

export default class CheckboxBinder extends BasePriceBinder {
	constructor(id, title, calculator, summaryDisplayer, priceFormatter) {
		super(id, title, calculator, summaryDisplayer, priceFormatter);
		this.baseElement = document.getElementById(this.id);
		this.isActive = this.baseElement.checked;
	}

	initEvents() {
		this.baseElement.addEventListener('change', (e) => {
			this.isActive = e.target.checked;
			this.handleChange();
		});

		super.initEvents();
	}
}
